import { createSlice, PayloadAction } from '@reduxjs/toolkit';

interface ContentState {
  selectedCategoryId?: number;
}

const initialState: ContentState = {
  selectedCategoryId: undefined,
};

export const contentSlice = createSlice({
  name: 'content',
  initialState,
  reducers: {
    setCategoryId: (state, action: PayloadAction<number | undefined>) => {
      state.selectedCategoryId = action.payload;
    },
  },
});
export const { setCategoryId } = contentSlice.actions;
export default contentSlice.reducer;